'use client';
import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useModalStore } from '#pplx/frontend/aether/modals/store/useModalStore.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
const sidebarSessionSearchOpenedEvent = EVENT_PAYLOAD;
const LazySimpleCommandPalette = Dynamic(async () => {
    const { SimpleCommandPalette } = await import('#pplx/frontend/apps/ask/command-palette/SimpleCommandPalette.js');
    return { default: SimpleCommandPalette };
});
const selectSimpleCommandPaletteState = (store) => {
    const activeModal = Array.from(store.modals.values()).find((modal) => modal.modal === LazySimpleCommandPalette);
    return {
        activeModalId: activeModal?.id ?? null,
        removeModal: store.removeModal,
    };
};
export function useSimpleCommandPaletteModal(platformConfig) {
    const { openModal } = useModalContext();
    const { track } = useInstrumentation();
    const { activeModalId, removeModal } = useModalStore(selectSimpleCommandPaletteState);
    const openSimpleCommandPalette = useCallback(() => {
        track(sidebarSessionSearchOpenedEvent({ name: 'sidebar session search opened', data: {} }));
        const props = platformConfig ? { platformConfig } : {};
        openModal(LazySimpleCommandPalette, props, { replace: true });
    }, [openModal, platformConfig, track]);
    const toggleSimpleCommandPalette = useCallback(() => {
        if (activeModalId !== null) {
            removeModal({ id: activeModalId });
            return;
        }
        openSimpleCommandPalette();
    }, [activeModalId, openSimpleCommandPalette, removeModal]);
    return { openSimpleCommandPalette, toggleSimpleCommandPalette };
}
//# sourceMappingURL=useSimpleCommandPaletteModal.js.map